/*
 * Project: xpenser-client
 * FilePath: /src/app/components/auth/index.tsx
 * File: index.tsx
 * Created Date: Friday, September 18th 2020, 6:05:27 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import React, { ReactNode, createContext } from 'react'
import useAuthentication from '@hooks/authentication'

export interface IContext {
  isAuthenticated: boolean | null;
  setAuthentication: (state: boolean) => void;
}
export interface IProvider {
  children: ReactNode;
  verifyUrl: string;
}

const AuthenticationDefaultState: IContext = {
  isAuthenticated: false,
  setAuthentication: () => {}
}

export const Context = createContext(AuthenticationDefaultState)

export const Provider: React.FC<IProvider> = ({ children, verifyUrl }) => {
  const authentication = useAuthentication(verifyUrl)

  return (
    <Context.Provider value={authentication}>
      {children}
    </Context.Provider>
  )
}

export default {
  Context,
  Provider,
  Consumer: Context.Consumer
}
